<div class="d-flex flex-column flex-root h-100" id="kt_login_wrapper" style="height: 100%;background: white">
    <!--begin::Login-->
    <div class="login login-1 login-signin-on d-flex flex-column flex-lg-row  bg-white" id="kt_login">

        <div class="parent login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden  mx-auto    "  style="height: min-content">

            <div class="d-flex justify-content-lg-end justify-content-end align-items-end w-100 p-7" >
                <div class="flex-grow-2">
                    <img src="../../../../assets/media/project-logos/Logo.png" class="max-h-90px cursor-pointer" style="margin-left: 20px;max-height: 60px !important;" alt="" (click)="goToDashboard()"/>
                </div>
                <div class="align-self-center d-flex">

                    <i class="fas fa-bars cursor-pointer listing-margin-r-sm " style="color: darkgray;font-size: 2.5rem; display: flex;
align-self: center; margin-right: 12px"  [matMenuTriggerFor]="menu" ></i>

                    <a [routerLink]="" (click)="endSession()" class=" highlight -primary ml-10 font-weight-bolder font-size-h5 remove-icon">Logout</a>
                </div>
            </div>




            <mat-menu #menu="matMenu" style="padding: 20px !important;border-radius: 20px">
                <a mat-menu-item routerLink="/" class=" font-weight-bolder font-size-h5 ">My Will</a>
                <a  mat-menu-item routerLink="/finish" routerLinkActive="active" class=" font-weight-bolder font-size-h5">My Plan</a>
                <a mat-menu-item routerLink="/share" routerLinkActive="active"class=" font-weight-bolder font-size-h5">Invite</a>
                <a mat-menu-item routerLink="/download" routerLinkActive="active"class=" font-weight-bolder font-size-h5">Download</a>
<!--                <a mat-menu-item routerLink="/review" routerLinkActive="active"class=" font-weight-bolder font-size-h5" style="color: #ef8c43">Review  Will</a>-->
                <a  [routerLink]="" (click)="endSession()"  mat-menu-item class=" font-weight-bolder font-size-h5 sm-remove-icon">Logout</a>
            </mat-menu>









            <!--end::Content-->
        </div>
        <!--end::Login-->
    </div>


    <div >


        <!-- <div class="d-flex justify-content-center align-content-center mb-15" style="background: white ; height: 100%"> -->
        <div class="d-flex justify-content-center align-content-center" style="background: white ; height: 100%">


            <div style="" class="review">

                <div class="pb-13 pt-lg-0 pt-5">
                    <p class="font-weight-bolder text-dark text-align-center font-heading mt-15" style="font-size: 2.4rem !important;">
                        Review your Will</p>

                    <p class="text-align-center font-heading mt-5" style="font-size: 1.6rem !important; color: #8F8F8F">
                        Review your Will below before completing your Will</p>


                </div>
                <img src="./assets/media/misc/vector-right.svg" style=" margin-right: 10px" alt="" class="right-vector "/>

                <img src="./assets/media/misc/vector-left.svg" style=" margin-right: 10px" alt="" class="left-vector "/>

                <ngb-accordion #acc="ngbAccordion" closeOthers="false" style="border-radius: 50px " (panelChange)="toggleAccordian($event)"  >


                    <ng-container *ngFor="let item of processListing; let  index = index">

                        <ngb-panel [id]="item.id" style="background: white !important;border-radius: 50px ;">
                            <ng-template ngbPanelHeader let-opened="opened" style="border-radius: 50px">
                                <button ngbPanelToggle style="width: 100%; background: white;font-size: 0 ; border-radius: 50px;padding-bottom: 20px" class="text-left no-border bt">

                                    <div class="d-flex align-items-center  listing-item" [class.collapsed]="!opened" style="background: wheat">
                                        <img  [src]="getIcon(item.id,getFinishedItem(item,processListing, index))"    alt="" title="" style=" border-radius: 15px;object-fit: contain" width="40" height="40">

                                        <div class="form-check form-check-custom form-check-solid mx-5"></div>
                                        <div class="flex-grow-1"><h3 class="listing-text-color text-gray-800 text-hover-primary fw-bolder fs-6 cursor-pointer"> Step {{index + 1 }}:  {{item.label}}</h3></div>

                                        <i class="fas theme-color-orange" style="font-size: 2.0rem" [ngClass]=" expandAccordian(item)? item.chevUp:item.chevDown"> </i>


                                    </div>

                                </button>
                            </ng-template>


                            <ng-template ngbPanelContent>
                                <app-summary-status [isFinish]="true" *ngIf="index==0"></app-summary-status>
                                <app-executor-summary [isFinish]="true" *ngIf="index==1"></app-executor-summary>

                                <app-estate-summary *ngIf="index ==2" [isFinish]="true"></app-estate-summary>
                                <app-gift-summary [isFinish]="true" *ngIf="index==3"></app-gift-summary>
                                <app-funeral-summary [isFinish]="true" *ngIf="index==4"></app-funeral-summary>
                            </ng-template>

                        </ngb-panel>

                    </ng-container>


                </ngb-accordion>


            </div>
        </div>





    </div>

    <!-- more charities modal -->







    <!--<i class="fa fa-check-circle" aria-hidden="true"></i>-->
